import React from 'react'
import Rheostat from 'rheostat'
import NumberFormat from 'react-number-format'
import { RheostatSlider } from '../../../utils/style'
import { string, func, array, number, shape } from 'prop-types'
import { Flex } from 'rebass'
import PseudoInput from './PseudoInput'
import PseudoSeparator from './PseudoSeparator'
import calculateRange from '../../../../lib/range-calculator'
import rounder from '../../../../lib/rounder'

const findMax = (data) => data.reduce((max, value) => Math.max(max, value), 0)

const Pit = ({ style, children, max, hist }) => (
  <div
    style={{
      ...style,
      background: '#a2a2a2',
      width: `${100 / (Object.keys(hist).length - 1)}%`,
      height: (25 / max) * hist[children],
      bottom: 5
    }}
  />
)

const histogram = (min, max, values, binWidth) => {
  const bins = []
  for (let n = min; n <= max; n += binWidth) {
    bins[n] = 0
  }
  return values.reduce((hist, value) => {
    bins[Math.floor(value / binWidth) * binWidth] += 1
    return bins
  }, bins)
}

class RangeInput extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onRangeChange = this.onRangeChange.bind(this)
    this.onChange = this.onChange.bind(this)
    this.calcValues(this.props)
    const { values } = this.props
    this.state = {
      values: values || { min: this.min, max: this.max }
    }
  }

  UNSAFE_componentWillReceiveProps({ values, data, step }) {
    if (data) {
      this.calcValues({ data, step })
      this.setState({
        data,
        values: values || { min: this.min, max: this.max }
      })
    } else {
      this.setState({ values: values || { min: this.min, max: this.max } })
    }
  }

  onChange(slider) {
    if (isNaN(slider.values[0]) || isNaN(slider.values[1])) return false
    if (
      slider.values[0] !== this.state.values.min ||
      slider.values[1] !== this.state.values.max
    ) {
      this.props.onChange({
        values: { min: slider.values[0], max: slider.values[1] }
      })
    }
  }

  onRangeChange(slider) {
    this.setState({
      values: { min: slider.values[0], max: slider.values[1] }
    })
  }

  calcValues({ data, step }) {
    const range = calculateRange(data)
    const { floor, ceil, round } = rounder(step)
    this.round = round
    this.min = floor(range.min)
    this.max = ceil(range.max)
    this.snapPoints = []
    for (let n = this.min; n <= this.max; n += step) {
      this.snapPoints.push(n)
    }
    this.hist = histogram(this.min, this.max, data, step)
    this.maxHist = findMax(this.hist)
  }

  render() {
    const HistoPit = (props) => (
      <Pit {...props} max={this.maxHist} hist={this.hist} />
    )
    return (
      <div>
        <RheostatSlider py={20} mt={25} mb={15} mx={22}>
          <Rheostat
            min={this.min}
            max={this.max}
            values={[this.state.values.min, this.state.values.max]}
            snap
            snapPoints={this.snapPoints}
            pitComponent={HistoPit}
            pitPoints={this.snapPoints.slice(0, -1)}
            onChange={this.onChange}
            onValuesUpdated={this.onRangeChange}
          />
        </RheostatSlider>
        <Flex px={12}>
          <PseudoInput width={'43%'}>
            <NumberFormat
              value={this.round(this.state.values.min)}
              displayType="text"
              thousandSeparator
              prefix={this.props.prefix}
            />
          </PseudoInput>
          <PseudoSeparator width={'14%'}>to</PseudoSeparator>
          <PseudoInput width={'43%'}>
            <NumberFormat
              value={this.round(this.state.values.max)}
              displayType="text"
              thousandSeparator
              prefix={this.props.prefix}
            />
          </PseudoInput>
        </Flex>
      </div>
    )
  }
}

RangeInput.defaultProps = {
  data: [],
  values: null,
  prefix: '',
  step: 100
}

RangeInput.propTypes = {
  onChange: func,
  data: array,
  values: shape({ min: number, max: number }),
  prefix: string,
  step: number
}

export default RangeInput
